'use client'

import { Typography, Box, styled } from '@mui/material'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React, { MouseEvent, ReactNode, memo, useMemo } from 'react'

type NavMenuItemProps = {
  href: string
  title: string
  Image: ReactNode
  callback?: (event: MouseEvent<HTMLAnchorElement>) => void
}

const NavLink = styled(Link)(() => ({
  textDecoration: 'none',
}))

const ItemLabel = styled(Typography)(() => ({
  // The landing site sets its menu in TheRiola, uppercase. Sizes are unchanged
  // so the bar keeps its measure.
  fontFamily: 'var(--font-display), var(--font-nunito), sans-serif',
  textTransform: 'uppercase',
  letterSpacing: '0.02em',
  fontWeight: '400',
  fontSize: '1rem',
  color: 'var(--dewi_colors_gray_0)',
}))

const NavMenuBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
}))

const NavMenuItem = ({
  href,
  title,
  Image,
  callback = () => {},
}: NavMenuItemProps) => {
  const pathname = usePathname()

  const isSelected = useMemo(() => {
    const pathName = pathname.split('/')[1]
    return `/${pathName}` === href
  }, [pathname, href])

  return (
    <NavLink onClick={callback} href={href} prefetch={false}>
      <NavMenuBox>
        <Box
          sx={{
            display: 'flex',
            color: 'var(--dewi_colors_gray_0)',
            opacity: isSelected ? 1 : 0.55,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {Image}
        </Box>
        <ItemLabel
          variant="h6"
          sx={{
            opacity: isSelected ? 1 : 0.55,
          }}
        >
          {title}
        </ItemLabel>
      </NavMenuBox>
    </NavLink>
  )
}

export default memo(NavMenuItem)
